import { useStatsigClient } from '@statsig/react-bindings';
import { useEffect, useState } from 'react';

import { setTelemetryID } from '../app/apiScreenSlice';
import { store } from '../app/store';
import Gates from '../statsig/gates';

const stytchPublicToken =
  'public-token-test-86991a9b-935a-407e-b5fb-9253a99bcc64';

export const useStytchTelemetryInit = (): void => {
  const [isScriptLoaded, setIsScriptLoaded] = useState(false);
  const { checkGate } = useStatsigClient();

  useEffect(() => {
    if (!checkGate(Gates.CollectStytchDeviceIntelligence)) return;
    if (window.stytchTelemetry || window.GetTelemetryID) return;

    const script = document.createElement('script');
    script.src = 'https://elements.stytch.com/telemetry.js';
    script.async = true;

    script.onload = () => {
      setIsScriptLoaded(true);
    };
    document.head.appendChild(script);

    return () => {
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
      setIsScriptLoaded(false);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!isScriptLoaded) return;
    if (typeof window.GetTelemetryID !== 'function') return;
    window
      .GetTelemetryID({
        publicToken: stytchPublicToken,
      })
      .then((telemetryID: string) => {
        store.dispatch(setTelemetryID(telemetryID));
      })
      .catch((error: any) => {
        console.error('Error getting telemetryID: ', error);
      });
  }, [isScriptLoaded]);
};
